import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="relative z-10 mt-12 px-3 pb-6 md:px-4 md:pb-8 lg:px-5">
      <div className="mx-auto max-w-[92rem] rounded-3xl frost-panel px-6 py-12">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="text-2xl font-black tracking-tight text-ink">
              roam<span className="text-warm">.</span>
            </Link>
            <p className="mt-4 text-sm text-ink-light leading-relaxed max-w-xs">
              AI-native travel planning with live flight and hotel intelligence,
              wrapped in one continuous experience.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-ink-light/70 mb-5">
              Product
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-ink-light hover:text-ink transition-colors">
                  Plan a Trip
                </Link>
              </li>
              <li>
                <Link to="/trips" className="text-ink-light hover:text-ink transition-colors">
                  My Trips
                </Link>
              </li>
              <li>
                <span className="text-ink-light/60 cursor-default">Explore Destinations</span>
              </li>
              <li>
                <span className="text-ink-light/60 cursor-default">Travel Guides</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-ink-light/70 mb-5">
              Company
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <span className="text-ink-light/60 cursor-default">About</span>
              </li>
              <li>
                <span className="text-ink-light/60 cursor-default">Careers</span>
              </li>
              <li>
                <span className="text-ink-light/60 cursor-default">Blog</span>
              </li>
              <li>
                <span className="text-ink-light/60 cursor-default">Press</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-ink-light/70 mb-5">
              Support
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <span className="text-ink-light/60 cursor-default">Help Center</span>
              </li>
              <li>
                <span className="text-ink-light/60 cursor-default">Privacy Policy</span>
              </li>
              <li>
                <span className="text-ink-light/60 cursor-default">Terms of Service</span>
              </li>
              <li>
                <span className="text-ink-light/60 cursor-default">Contact</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-ink-light/70">
            &copy; {new Date().getFullYear()} roam. All rights reserved.
          </p>
          <div className="flex items-center gap-5 text-ink-light/70">
            <a href="#" className="hover:text-ink transition-colors" aria-label="Twitter">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <a href="#" className="hover:text-ink transition-colors" aria-label="Instagram">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
              </svg>
            </a>
            <a href="#" className="hover:text-ink transition-colors" aria-label="YouTube">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
